window.onpageshow = function() {
   $('.js-wait-for-image-wrapper').waitForImages(true).done(function() {
      $('.hidden-before-images-ready').animate({
         opacity: '1'
      }, 350);
   });
};

$(document).ready(function() {

   FastClick.attach(document.body);



  $.fn.serializeObject = function() {
      var o = Object.create(null),
          elementMapper = function(element) {
              element.name = $.camelCase(element.name);
              return element;
          },
          appendToResult = function(i, element) {
              var node = o[element.name];

              if ('undefined' != typeof node && node !== null) {
                  o[element.name] = node.push ? node.push(element.value) : [node, element.value];
              } else {
                  o[element.name] = element.value;
              }
          };

      $.each($.map(this.serializeArray(), elementMapper), appendToResult);
      return o;
  };






   // VIDEO

   $('.fitvids').fitVids();

   // BROWSER SCROLLED DETECT


   function scrolledCheck() {

      if ($(window).scrollTop() > 0) {
         $('body').addClass('browser-scrolled');
      } else {
         $('body').removeClass('browser-scrolled');
      }

      if ($(window).scrollTop() > $('.desktop-navbar').outerHeight()) {
         $('body').addClass('navbar-condensed');
      } else {
         $('body').removeClass('navbar-condensed');
      }
   }

   scrolledCheck();

   $(window).on('scroll', function() {
      scrolledCheck();
   });



   // 100vh BACKUP FUNCTION

   function setHeight100vh() {
      $('.height-100vh').height($(window).height());
   }
   if (!Modernizr.cssvhunit) {
      setHeight100vh();
      $(window).resize($.debounce(250, setHeight100vh));
   }

   //SEARCH
   $('.desktop-navbar-search').hover(
      function() {
         $(this).addClass('open');
      },
      function() {
         $(this).removeClass('open');
      });


   //DROPDOWN

   if ($('html.mod-no-mobile').length) {

      $('.js-dropdown-hover').hover(
         function() {
            $(this).addClass('open');
         },
         function() {
            $(this).removeClass('open');
         });

   }

   if ($('html.mod-mobile').length) {

      $('.js-dropdown-header-click').click(function() {

         var $dropdown = $(this).parent();

         $dropdown.toggleClass('open')
            .siblings('.dropdown').removeClass('open');

      });

   }


   //////////////////////////////////////// NAVBAR DROPDOWN /////////////////////////////////////
  $(document).ready(function(){


    $(document).on('click', '.js-dropdown-toggle', function(e) {
        e.preventDefault();
        var $dropdown = $(this).parent();

        $dropdown.toggleClass('open')
                .siblings().removeClass('open');

    });





    var location = window.location.href;
    if (location.includes('collections')){

      var handle = location.split('/')[location.split('/').length - 1];
      var navs = $('.link-toggle');

    Object.keys(navs).forEach(function(el){
      var navText = navs[el].innerText;
      if (navText != undefined) {
        if (navText.toLowerCase().includes(handle)){
          var active = navs[el];
          active.parentElement.firstElementChild.nextElementSibling.classList.add('open');
        }
      }
    });

      var subnavs = $('.link-toggle').parent().find('.dropdown-ul li a');
       Object.keys(subnavs).forEach(function(el){
          var subNavText = $.trim(subnavs[el].text);
          if (subNavText != undefined) {
            if (subNavText.toLowerCase().includes(handle)){
              var subActive = subnavs[el].parentElement.parentElement.classList.add('open');
            }
          }
        });
  }

});

   // COLOR THE DROPDOWN
   $(document).on('mouseenter', '.js-color-the-dropdown', function(){
     $(this).parents('.dropdown').find('.dropdown-color-me').css('background-color', $(this).data('color-hex'));
     // $('.embroidery-preview').css('color', $(this).data('color-hex'));
   });

   $(document).on('mouseleave', '.js-color-the-dropdown', function(){
     $(this).parents('.dropdown').find('.dropdown-color-me').css('background-color', 'white');
   });




   //MINICART

   if ($('html.mod-no-mobile').length) {
      $(document).on('click', '.desktop-mini-cart-trigger', function() {
         $('body').addClass('mini-cart-open');
      });

      // $('.mini-cart').mouseleave(function() {
      //    $('body').removeClass('mini-cart-open');
      // });

   }

   // BODY CLASS

   $(document).on('click', '.js-body-add-class', function() {
      $('body').addClass($(this).data('body-class'));
   });

   $(document).on('click', '.js-body-remove-class', function() {
      $('body').removeClass($(this).data('body-class'));
   });

   $(document).on('click', '.js-body-class-toggle', function() {
      $('body').toggleClass($(this).data('body-class'));
   });

   // ELEMENT FADEIN FADEOUT

   $(document).on('click', '.js-element-fadein', function() {
      $($(this).data('element-selector')).fadeIn();
   });
   $(document).on('click', '.js-element-fadeout', function() {
      $($(this).data('element-selector')).fadeOut();
   });
   $(document).on('click', '.js-element-toggle', function() {
      $($(this).data('element-selector')).fadeToggle(300);
   });


   // STOP PROPAGATION

   $(document).on('click', '.js-stop-propagation', function(event) {
      event.stopPropagation();
   });


   // SCROLL TO ELEMENT

   $(document).on('click', '.js-body-scroll-to-element', function() {
      var elementSelector = $(this).data('element-selector');
      var scrollOffset = $(this).data('scroll-offset');
      $('html, body').animate({
         scrollTop: $(elementSelector).offset().top - scrollOffset
      }, 600, 'easeOutExpo');
   });





   // IMAGE SWAP

   var imageSourceSwap = function() {

      var $this = $(this).find('.product-card-image');
      var sourceAlt = $this.data('src-alt');
      $this.data('src-alt', $this.attr('src'));
      $this.attr('src', sourceAlt);

   };

   $('.js-product-card-image-swap').hover(imageSourceSwap, imageSourceSwap);

   // PRODUCT IMAGE FULLSCREEN

   $(document).on('click', '.js-product-image-fullscreen', function() {
      $('.product-image-popup').fadeIn().find('img').prop('src', $(this).find('img').prop('src'));
   });



    // PROMO POPUP

    if ( !$.cookie('promo_seen')) {
      var inHalfADay = 0.5;
      setTimeout(function(){
        $('.promo-popup').fadeIn();
        $.cookie('promo_seen', 'true', {
           expires: inHalfADay,
           path: '/'
        });
      }, 5000);

    }

   // EMAIL SUBSCRIBE POPUP

   if ( !$.cookie('site_visited')) {
     setTimeout(function(){
       $('.subscribe-popup').fadeIn();
       $.cookie('site_visited', 'true', {
          expires: 15,
          path: '/'
       });
     }, 10000);

   }

   // LAUNCH POPUP

      if (!$.cookie('popup-viewed')) {
         $('.launch-popup').fadeIn();
         $.cookie('popup-viewed', 'true', {
            expires: 15,
            path: '/'
         });
      }

});
